import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

const LargeFileWarningModal = ({
  open,
  onClose,
  title = 'Large file warning',
  confirmationMessage = 'Your file exceeds the 2GB recommendation which may cause excessively long upload times or errors. Please reduce the file size by removing unnecessary information, such as extra layers.',
  continueButtonText = 'Continue anyway',
  cancelButtonText = 'Cancel upload',
  onContinue,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        '.MuiDialog-paper': {
          width: '510px',
          boxShadow:
            '0px 8px 10px -5px rgba(0, 0, 0, 0.2),0px 16px 24px 2px rgba(0, 0, 0, 0.14),0px 6px 30px 5px rgba(0, 0, 0, 0.12)',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          borderBottom: '1px solid rgba(0, 37, 71, 0.12)',
        }}
      >
        <div className='text-heading-style-1'>{title}</div>
      </DialogTitle>
      <DialogContent sx={{ padding: '20px 24px !important' }}>
        <div className='normal-text-style-2' style={{ lineHeight: '28px' }}>
          {confirmationMessage}
        </div>
      </DialogContent>
      <DialogActions sx={{ padding: '16px 24px' }}>
        <Button onClick={onContinue} variant='text' color='primary' size='medium'>
          {continueButtonText}
        </Button>
        <Button
          variant='contained'
          className='primary-contained-button-medium'
          onClick={onClose}
        >
          {cancelButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LargeFileWarningModal;
